import * as React from 'react';
import BillingMethod from './billing_method';
import Location from '../lib/wrapped_location';

export default function PaywallBillingMethod() {
  return (
    <BillingMethod
      onUpdateBillingMethodSuccess={Location.reload}
      returnURL={Location.href}
    />
  );
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/billing/paywall_billing_method.tsx